module.exports = __webpack_public_path__ + "img/inco1Ac.deaa0f19.png";